/* eslint-disable react/require-default-props */
import React from 'react';
import { IssueStatusEnum } from '@features/IIMReview/types';
import { translate } from '@utils/i18n';
import { Text } from '@ui';
import { Tag } from '@ui/atoms/Tag/Tag';
import DeviceInfoToggle from './DeviceInfoToggle';
import IssueLayout from './IssueLayout';
import './styles.scss';
/** Converts snake_case or camelCase to Title Case. */
function humanize(str) {
    return str
        .replace(/_/g, ' ')
        .replace(/([A-Z])/g, ' $1')
        .trim()
        .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
}
/** Splits "Title: detail sentence" into { title, detail }. */
function parseDescription(description) {
    const colonIdx = description.indexOf(': ');
    if (colonIdx === -1)
        return null;
    return {
        title: description.slice(0, colonIdx),
        detail: description.slice(colonIdx + 2)
    };
}
/**
 * Renders a description string with formatted title + detail.
 * Comma-separated short tokens (pixel-analysis reasons) are shown as Tag
 * components. All snake_case tokens are humanized to readable labels.
 */
function FormattedDescription({ description }) {
    const parsed = parseDescription(description);
    if (!parsed) {
        return (React.createElement(Text, { variant: "body", as: "p", className: "issue-card__description-detail" }, description));
    }
    const { title, detail } = parsed;
    const tokens = detail.split(', ').map((t) => t.trim());
    const isTagList = tokens.length >= 2 && tokens.every((t) => t.length <= 40 && !t.includes('. '));
    return (React.createElement("div", { className: "issue-card__description" },
        React.createElement(Text, { variant: "x-small", as: "p", className: "issue-card__description-title" }, title),
        isTagList ? (React.createElement("div", { className: "issue-card__description-tags" }, tokens.map((token) => (React.createElement(Tag, { key: token, label: humanize(token), variant: "gray", colorStyle: "pastry", size: "base", readOnly: true }))))) : (React.createElement(Text, { variant: "body", as: "p", className: "issue-card__description-detail" }, detail))));
}
export default function DefaultIssueCard({ issue, defaultExpanded, onToggle, onUpdateIssue, onUndoAction, readOnly = false }) {
    var _a;
    const isHighImpact = ((_a = issue.issueData) === null || _a === void 0 ? void 0 : _a.highImpact) || false;
    const status = issue.status || IssueStatusEnum.Detected;
    const handleSuggestCorrection = () => {
        onUpdateIssue(issue.id, status, true);
    };
    const handleDismissIssue = () => {
        onUpdateIssue(issue.id, IssueStatusEnum.DismissedByBackOffice, false);
    };
    const highImpactBadge = isHighImpact ? (React.createElement("span", { className: "issue-card__badge issue-card__badge--high-impact" }, translate('high_impact', { namespace: 'features.iim_review.issue_card' }))) : undefined;
    return (React.createElement(IssueLayout, { issueType: issue.issueType, badge: highImpactBadge, status: status, defaultExpanded: defaultExpanded, onToggle: onToggle, onSuggestCorrection: handleSuggestCorrection, onDismissIssue: handleDismissIssue, onUndoAction: onUndoAction, readOnly: readOnly, statusChanges: issue.statusChanges, markedForSuggestion: issue.markedForSuggestion },
        React.createElement(React.Fragment, null,
            React.createElement(FormattedDescription, { description: issue.description || '' }),
            issue.inspectable && (React.createElement(DeviceInfoToggle, { inspectable: issue.inspectable, onToggle: (_e) => { } })))));
}
